import { BP, Colors, mq, mqMax } from '~/styles';
import type { TStyleSheet } from '~/types/emotion-styles';

const INNER_ITEM_HEIGHT_LARGE = '9rem';
const INNER_ITEM_HEIGHT_DEFAULT = '5.8rem';

const styles: TStyleSheet = {
  contactSheetContainer: {
    alignItems: 'flex-start',
    borderRadius: '10rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    paddingLeft: '1.5rem',
    paddingRight: '1.5rem',
    top: '80px',
    minWidth: 280,
    [mqMax(BP.Large)]: {
      width: '100%',
      paddingLeft: '0',
    },
    [mqMax(BP.Medium)]: {
      width: '100%',
      paddingLeft: '0',
      paddingRight: '0',
    },
  },
  socialMediaLinksContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    height: INNER_ITEM_HEIGHT_DEFAULT,
    justifyContent: 'space-between',
    width: '75%',
    [mqMax(BP.Large)]: {
      height: INNER_ITEM_HEIGHT_LARGE,
      width: '25%',
    },
    [mqMax(BP.Medium)]: {
      justifyContent: 'space-around',
      width: '100%',
    },
  },
  socialMediaLinkClickableIcon: {
    cursor: 'pointer',
    transition: 'transform 0.2s ease-in-out',
    '&:hover': {
      transform: 'scale(1.25)',
    },
    '&:active': {
      transform: 'scale(2)',
    },
  },
  utterancePhraseContainer: {
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    height: INNER_ITEM_HEIGHT_LARGE,
    justifyContent: 'center',
    [mqMax(BP.Medium)]: {
      width: '100%',
    },
  },
  utterancePhraseText: {
    color: 'black',
    height: '3rem',
    whiteSpace: 'nowrap',
  },
  phoneNumberContainer: {
    alignItems: 'center',
    color: 'black',
    display: 'flex',
    flexDirection: 'row',
    gap: '1rem',
    height: INNER_ITEM_HEIGHT_DEFAULT,
    [mqMax(BP.Large)]: {
      gap: '1.25rem',
      height: INNER_ITEM_HEIGHT_LARGE,
    },
    [mqMax(BP.Medium)]: {
      width: '100%',
    },
  },
  phoneNumberText: {
    whiteSpace: 'nowrap',
    display: 'flex',
    gap: '12px',
  },
  divider: {
    height: 1,
    width: '100%',
    backgroundColor: Colors.greyEB,
  },
};

export default styles;
